/**
 *   Created by FANGlh on 2019/1/19 12:32.
 *   Desc:
 */

import React,{Component} from 'react';
import {Link} from 'react-router-dom';
import './LeaveItem.css';

export default class LeaveItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: this.props.itemdata
        }
    }

    render() {
        const {item} = this.state;
        return (
            <div style={{padding:10}}>
                <Link to={'/leavedetail/' + this.props.role + '/' + item.lvId}>
                    <div style={{backgroundColor:'#FFF',width:'100%',padding:10,borderRadius:10}} onClick = {this.ItemClick.bind(this,this.props.index)}>
                        <div className="leave_row_sty">
                            <div style={{fontSize: 16, color: "#000000",width:'60%',textAlign:'left'}}> {item.title}</div>
                            <div style={{width:'40%',textAlign:'right'}}>
                                {
                                    this.state.role == "parent" ? '' :
                                        <div>
                                            {
                                                item.leaveMessages.length == 0 ?
                                                    <div style={{fontSize: 12, color: "#FA5200"}}>未回复</div>
                                                    : <div style={{fontSize: 12, color: "##686868"}}>已回复</div>
                                            }
                                        </div>
                                }
                            </div>
                        </div>
                        <div className="leave_row_sty" style={{marginTop:5}}>
                            <div  style={{fontSize: 14, color: "#999999",width:'25%'}}>请假时间：</div>
                            <div style={{fontSize: 14, color: "#666666",width:'75%'}}>{item.startTime}—{item.endTime}</div>
                        </div>

                        <div className="leave_row_sty" style={{marginTop:5}}>
                            <div style={{fontSize: 14, color: "#999999",width:'25%'}}>请假事由：</div>
                            <div style={{fontSize: 14, color: "#666666",width:'75%',wordWrap:'break-word'}}>{item.content}</div>
                        </div>
                    </div>
                </Link>
            </div>
        )
    }
    ItemClick =(index)=>{
        console.log('ItemClick_index',index)
        this.props.onItemClick(index)
    }
}